import React, { useEffect, useState } from "react";
import { X, Mail } from "lucide-react";
import "./RenameEsimModal.css"; // can reuse same CSS tokens as Rename modal
import { useLanguage } from "../../i18n/LanguageContext";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function ShareEsimModal({
                                           open,
                                           onClose,
                                           simId,
                                           onShared,    // optional callback after success
                                       }) {
    const [email, setEmail] = useState("");
    const [saving, setSaving] = useState(false);
    const { t } = useLanguage();
    const valid = EMAIL_RE.test(email.trim());

    useEffect(() => {
        if (open) setEmail("");
    }, [open]);

    const submit = async () => {
        if (!valid || saving) return;
        try {
            setSaving(true);
            const resp = await fetch("https://api.artamobile.id/v1/esims/share", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ SimId: simId, recipient: email.trim() }),
            });
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            onShared?.();
            onClose();
            alert(t("shareModal.success"));
        } catch (e) {
            console.error(e);
            alert(t("shareModal.failed"));
        } finally {
            setSaving(false);
        }
    };

    if (!open) return null;

    return (
        <div className="rename-modal-backdrop" role="dialog" aria-modal="true">
            <div className="rename-modal">
                <button className="modal-close" aria-label={t("common.close")} onClick={onClose}>
                    <X size={20} />
                </button>

                <h3 className="modal-title">{t("shareModal.title")}</h3>

                <div className="modal-info">
                    <Mail size={18} />
                    <span>{t("shareModal.info")}</span>
                </div>

                <label className="input-label" htmlFor="share-email">{t("shareModal.label")}</label>
                <input
                    id="share-email"
                    className="modal-input"
                    type="email"
                    placeholder={t("shareModal.placeholder")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoFocus
                />
                {!valid && email.length > 0 && (
                    <div className="char-left" style={{ color: "#dc2626" }}>
                        {t("shareModal.invalid")}
                    </div>
                )}

                <div className="modal-actions">
                    <button className="primary" disabled={!valid || saving} onClick={submit}>
                        {saving ? t("shareModal.sending") : t("shareModal.send")}
                    </button>
                </div>
            </div>
        </div>
    );
}
